export default [
    {
        id: 1,
        name_ca: 'Tendència a l\'alça',
        name_es: 'Tendencia al alza',
        name_en: 'Upward trend'
    }, {
        id: 2,
        name_ca: 'Tendència a l\'alça moderada',
        name_es: 'Tendencia al alza moderada',
        name_en: 'Moderate upward trend'
    }, {
        id: 3,
        name_ca: 'Tendència a mantenir-se estable',
        name_es: 'Tendencia a mantenerse estable',
        name_en: 'to remain stable'
    }, {
        id: 4,
        name_ca: 'Tendència a la baixa moderada',
        name_es: 'Tendencia a la baja moderada',
        name_en: 'Moderate downward trend'
    }, {
        id: 5,
        name_ca: 'Tendència a la baixa',
        name_es: 'Tendencia a la baja',
        name_en: 'Downward trend'
    }
]



// WEBPACK FOOTER //
// ./src/options/trends.js